import { useMemo } from 'react';
import _get from 'lodash/get';
import { Documentation, FilterGroupingEnum } from 'graphql-common';
import { useEdmDocumentationsLightQuery } from '@lib/graphql-common';

export default function useDocumentsMap(docIds: string[]) {
  const { data, previousData, loading } = useEdmDocumentationsLightQuery({
    variables: {
      filters: [
        {
          id: {
            grouping: FilterGroupingEnum.And,
            predicate: { in: docIds },
          },
        },
      ],
      limit: docIds.length || 1,
    },
    skip: docIds.length === 0,
    fetchPolicy: 'cache-and-network',
  });

  const docsData = data || previousData;

  const documentsMap = useMemo(() => {
    const collection = _get(docsData, 'data.collection', []) as Documentation[];
    const map = new Map<string, Documentation>();
    collection.forEach((doc) => map.set(doc.id, doc));
    return map;
  }, [docsData]);

  const firstLoading = loading && !docsData && docIds.length > 0;

  return { documentsMap, loading: firstLoading };
}
